import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";
const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    extraShiftsUpdted: null,
    studios: [],
    extraShifts: [],
    monthInfo: [],
    accountUpdated: false,
    accountDeleted: false,
    pendingRequest: false,
    error: {
        status: false,
        message: "",
    },
    success: {
        status: false,
        message: "",
    },
};

export const getExtraShifts = createAsyncThunk(
    "dealers/extraShifts",
    async (args, { rejectWithValue }) => {
        try {
            const response = await axios.get("dealers/extraShifts", {
                headers: {
                    'x-auth': getToken(),
                },
            });
            return response.data;  // Assuming response.data contains the necessary shift data
        } catch (error) {
            const message = error?.response?.data?.message || "An error occurred";
            return rejectWithValue({ message });
        }
    }
);

export const answerNotification = createAsyncThunk(
    "dealers/answerNotification",
    async (args, { rejectWithValue }) => {
        try {
            const response = await axios.post("dealers/answerNotification", args,
            {
                headers: {
                    'x-auth': getToken(),
                },
            });
            return response.data;  // Assuming response.data contains the necessary shift data
        } catch (error) {
            const message = error?.response?.data?.message || "An error occurred";
            return rejectWithValue({ message });
        }
    }
);

export const getMonthInfo = createAsyncThunk(
    "dealers/getMonthInfo",
    async (args, { rejectWithValue }) => {
        try {
            const response = await axios.get("dealers/getMonthInfo",
            {
                headers: {
                    'x-auth': getToken(),
                },
            });
            return response.data;  // Assuming response.data contains the necessary shift data
        } catch (error) {
            const message = error?.response?.data?.message || "An error occurred";
            return rejectWithValue({ message });
        }
    }
);

const dealerSlice = createSlice({
    name: "dealers",
    initialState,
    reducers: {
        reset(state) {
            state.error.status = false;
            state.success.status = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getExtraShifts.pending, (state) => {
                state.progress = true; // Set progress to true while the request is pending
            })
            .addCase(getExtraShifts.fulfilled, (state, action) => {
                const payload = action.payload;

                state.progress = false; // Reset progress once the request is completed
                state.studios = payload.studios; // Reset progress once the request is completed
                delete payload.studios
                state.extraShifts = payload; // Assuming payload is the shifts data
                state.success = { status: true, message: "Shifts loaded successfully" };
            })
            .addCase(getExtraShifts.rejected, (state, action) => {
                state.progress = false; // Reset progress on failure
                state.error = { status: true, message: action.payload?.message || "An error occurred" };
            });
        
        builder
            .addCase(answerNotification.pending, (state, action) => {
                state.pendingRequest = true
            })
            .addCase(answerNotification.fulfilled, (state, action) => {
                const payload = action.payload;
                state.pendingRequest = false
                state.studios = payload.studios; 
                delete payload.studios
                state.extraShifts = payload; 
                state.extraShiftsUpdted = new Date(); 
            })
            .addCase(answerNotification.rejected, (state, action) => {
                state.pendingRequest = false
            });
        builder.addCase(getMonthInfo.pending, (state, action) => {
                state.monthInfo = {total: 0, worked: 0, salary: 0, bonusMonths: 0};
            })
            .addCase(getMonthInfo.fulfilled, (state, action) => {
                state.monthInfo = action.payload;
            })
            .addCase(getMonthInfo.rejected, (state, action) => {
                state.monthInfo = {total: 0, worked: 0, salary: 0, bonusMonths: 0};
            })
    },
});

export const dealerActions = dealerSlice.actions;
export const dealerReducer = dealerSlice.reducer;
